/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef, useCallback, useState, useEffect } from 'react'
import { FiMail, FiUser, FiSmartphone } from 'react-icons/fi'
import { MdSecurity } from 'react-icons/md'
import { BiCake } from 'react-icons/bi'
import * as Yup from 'yup'
import { Form } from '@unform/web'
import { FormHandles } from '@unform/core'
import { useHistory } from 'react-router-dom'
import { Collapse } from '@material-ui/core'
import moment from 'moment'
import {
  Container,
  Content,
  BtnVoltar,
  Line,
  RadioButton,
  BtnToggle,
  BtnModal,
} from './styles'
import Header from '../../components/Header'
import usePersistedState from '../../hooks/usePersistedState'
import Input from '../../components/Input'
import Button from '../../components/Button'
import InputHidden from '../../components/InputHidden'
import getValidationErrors from '../../utils/getValidationErrors'
import {
  UserData,
  FinancialIndicationData,
  LegalIndicationData,
  IndicationData,
} from '../../utils/interfaces'
import validaCPF from '../../utils/validaCPF'
import calculaIdade from '../../utils/calculaIdade'
import ModalBox from '../../components/Modal'
import InputSelect from '../../components/InputSelect'

const Responsavel: React.FC = () => {
  const [userData, setUserData] = usePersistedState<UserData>('userData', {} as UserData)

  const [
    financialIndicationData,
    setFinancialIndicationData,
  ] = usePersistedState<FinancialIndicationData>(
    'financialIndicationData',
    {} as FinancialIndicationData,
  )

  const [legalIndicationData, setLegalIndicationData] = usePersistedState<
    LegalIndicationData
  >('legalIndicationData', {} as LegalIndicationData)

  const [indicationData, setIndicationData] = usePersistedState<IndicationData>(
    'indicationData',
    {} as IndicationData,
  )

  const [menorIdade] = usePersistedState('menorIdade', false)
  const [respLegal, setRespLegal] = usePersistedState('respLegal', false)
  const [respFinanceiro, setRespFinanceiro] = usePersistedState(
    'respFinanceiro',
    false,
  )
  const [respLegalEqualFin, setRespLegalEqualFin] = usePersistedState(
    'respLegalEqualFin',
    'N',
  )

  const [pessoaIndicacao, setPessoaIndicacao] = usePersistedState(
    'Indicado',
    'N',
  )

  const [patrocIndicacao, setPatrocIndicacao] = useState({
    label:
      indicationData.dcrPatrocinadoraIndicacao
        ? indicationData.dcrPatrocinadoraIndicacao
        : '',
    value:
      indicationData.patrocinadoraIndicacao
        ? indicationData.patrocinadoraIndicacao
        : '',
  })

  const [parentIndicacao, setParentIndicacao] = useState({
    label:
      indicationData.dcrGrauParentescoIndicacao === undefined
        ? ''
        : indicationData.dcrGrauParentescoIndicacao,
    value:
      indicationData.grauParentescoIndicacao === undefined
        ? ''
        : indicationData.grauParentescoIndicacao,
  })

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [tipoPessoa, setTipoPessoa] = useState(pessoaIndicacao === 'N' ? 'P' : 'F')

  const history = useHistory()
  const formRef = useRef<FormHandles>(null)

  const handleClick = useCallback(() => {
    formRef.current?.submitForm()
  }, [])

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  const handleSubmit = useCallback(
    async data => {
      try {
        formRef.current?.setErrors({})
        const schema = Yup.object().shape({
          nomeResponsavelLeg: Yup.string().when('responsavelLeg', {
            is: 'S',
            then: Yup.string()
              .required('Nome do responsável legal é obrigatório')
              .matches(/\s/g, 'Digite o nome completo'),
          }),
          cpfResponsavelLeg: Yup.string().when('responsavelLeg', {
            is: 'S',
            then: Yup.string()
              .required('CPF obrigatório')
              .test(
                '',
                'CPF inválido',
                () =>
                  validaCPF(
                    data.cpfResponsavelLeg.replaceAll('.', '').replace('-', ''),
                  ) || data.cpfResponsavelLeg === '',
              ),
          }),
          birthdateResponsavelLeg: Yup.string().when('responsavelLeg', {
            is: 'S',
            then: Yup.string()
              .required('Data de nascimento obrigatória')
              .test(
                '',
                'Data inválida.',
                () =>
                  moment(
                    data.birthdateResponsavelLeg.split('/').reverse().join('-'),
                  ).isValid() || data.birthdateResponsavelLeg === '',
              )
              .test(
                '',
                'O responsável legal deve ter 18 anos ou mais.',
                () =>
                  calculaIdade(
                    data.birthdateResponsavelLeg.split('/').reverse().join('-'),
                  ) >= 18 || data.birthdateResponsavelLeg === '',
              )
              .test(
                '',
                'Data de nascimento inválida',
                () =>
                  calculaIdade(
                    data.birthdateResponsavelLeg.split('/').reverse().join('-'),
                  ) <= 115 || data.birthdateResponsavelLeg === '',
              ),
          }),
          telResponsavelLeg: Yup.string().when('responsavelLeg', {
            is: 'S',
            then: Yup.string()
              .max(15, 'Telefone inválido')
              .required('Celular obrigatório'),
          }),
          emailResponsavelLeg: Yup.string().when('responsavelLeg', {
            is: 'S',
            then: Yup.string()
              .required('E-mail é obrigatório')
              .email('Digite um e-mail válido'),
          }),

          nomeResponsavelFin: Yup.string().when('responsavelFin', {
            is: 'S',
            then: Yup.string()
              .required('Nome do responsável legal é obrigatório')
              .matches(/\s/g, 'Digite o nome completo'),
          }),
          cpfResponsavelFin: Yup.string().when('responsavelFin', {
            is: 'S',
            then: Yup.string()
              .required('CPF obrigatório')
              .test(
                '',
                'CPF inválido',
                () =>
                  validaCPF(
                    data.cpfResponsavelFin.replaceAll('.', '').replace('-', ''),
                  ) || data.cpfResponsavelFin === '',
              ),
          }),
          birthdateResponsavelFin: Yup.string().when('responsavelFin', {
            is: 'S',
            then: Yup.string()
              .required('Data de nascimento obrigatória')
              .test(
                '',
                'Data inválida.',
                () =>
                  moment(
                    data.birthdateResponsavelFin.split('/').reverse().join('-'),
                  ).isValid() || data.birthdateResponsavelFin === '',
              )
              .test(
                '',
                'O responsável legal deve ter 18 anos ou mais.',
                () =>
                  calculaIdade(
                    data.birthdateResponsavelFin.split('/').reverse().join('-'),
                  ) >= 18 || data.birthdateResponsavelFin === '',
              )
              .test(
                '',
                'Data de nascimento inválida',
                () =>
                  calculaIdade(
                    data.birthdateResponsavelFin.split('/').reverse().join('-'),
                  ) <= 115 || data.birthdateResponsavelFin === '',
              ),
          }),
          telResponsavelFin: Yup.string().when('responsavelFin', {
            is: 'S',
            then: Yup.string()
              .max(15, 'Telefone inválido')
              .required('Celular obrigatório'),
          }),
          emailResponsavelFin: Yup.string().when('responsavelFin', {
            is: 'S',
            then: Yup.string()
              .required('E-mail é obrigatório')
              .email('Digite um e-mail válido'),
          }),
          cpfIndicacao: Yup.string().when('pessoaIndicacao', {
            is: 'S',
            then: Yup.string()
              .required('CPF é obrigatório')
              .test(
                '',
                'CPF inválido',
                () =>
                  validaCPF(
                    data.cpfIndicacao.replaceAll('.', '').replace('-', ''),
                  ) || data.cpfIndicacao === '',
              ),
          }),
          nomeIndicacao: Yup.string().when('pessoaIndicacao', {
            is: 'S',
            then: Yup.string().required('Nome é obrigatório'),
          }),
          grauParentesco: Yup.string().when('pessoaIndicacao', {
            is: 'S',
            then: Yup.string().required('Selecione o grau de parentesco'),
          }),
          patrocinadoraIndicacao: Yup.string().when('pessoaIndicacao', {
            is: 'N',
            then: Yup.string().required('Patrocinadora é obrigatória'),
          })
        })

        await schema.validate(data, { abortEarly: false })

        await setLegalIndicationData({
          ...legalIndicationData,
          nomeResponsavelLeg: data.nomeResponsavelLeg,
          cpfResponsavelLeg: data.cpfResponsavelLeg,
          birthdateResponsavelLeg: data.birthdateResponsavelLeg
            .split('/')
            .reverse()
            .join('-'),
          telResponsavelLeg: data.telResponsavelLeg,
          emailResponsavelLeg: data.emailResponsavelLeg,
        })

        if (respLegalEqualFin === 'S' && respFinanceiro) {
          await setFinancialIndicationData({
            ...financialIndicationData,
            nomeResponsavelFin: legalIndicationData.nomeResponsavelLeg,
            cpfResponsavelFin: legalIndicationData.cpfResponsavelLeg,
            birthdateResponsavelFin: legalIndicationData.birthdateResponsavelLeg
              .split('/')
              .reverse()
              .join('-'),
            telResponsavelFin: legalIndicationData.telResponsavelLeg,
            emailResponsavelFin: legalIndicationData.emailResponsavelLeg,
          })
        } else if (respFinanceiro) {
          await setFinancialIndicationData({
            ...financialIndicationData,
            nomeResponsavelFin: data.nomeResponsavelFin,
            cpfResponsavelFin: data.cpfResponsavelFin,
            birthdateResponsavelFin: data.birthdateResponsavelFin
              .split('/')
              .reverse()
              .join('-'),
            telResponsavelFin: data.telResponsavelFin,
            emailResponsavelFin: data.emailResponsavelFin,
          })
        }
        if (pessoaIndicacao === 'S') {
          setIndicationData({
            ...indicationData,
            cpfIndicacao: data.cpfIndicacao,
            nomeIndicacao: data.nomeIndicacao,
            grauParentescoIndicacao: parentIndicacao.value,
            dcrGrauParentescoIndicacao: parentIndicacao.label,
            patrocinadoraIndicacao: '',
            dcrPatrocinadoraIndicacao: '',
          })
        } else {
          setIndicationData({
            ...indicationData,
            cpfIndicacao: '',
            nomeIndicacao: '',
            grauParentescoIndicacao: '',
            dcrGrauParentescoIndicacao: '',
            patrocinadoraIndicacao: patrocIndicacao.value,
            dcrPatrocinadoraIndicacao: patrocIndicacao.label,
          })
        }
        setUserData({
          ...userData,
          tipoPessoa
        })

        history.push('/goal-selection')
      } catch (err) {
        formRef.current?.setErrors(getValidationErrors(err))
      }
    },
    [
      setLegalIndicationData,
      legalIndicationData,
      respLegalEqualFin,
      respFinanceiro,
      setIndicationData,
      pessoaIndicacao,
      indicationData,
      parentIndicacao,
      patrocIndicacao,
      history,
      setFinancialIndicationData,
      financialIndicationData,
      tipoPessoa
    ],
  )

  const toggleRespLegalEqualFin = useCallback(
    isEqual => {
      setRespLegalEqualFin(isEqual)
      if (isEqual === 'S') {
        setFinancialIndicationData({
          ...financialIndicationData,
          nomeResponsavelFin: legalIndicationData.nomeResponsavelLeg,
          cpfResponsavelFin: legalIndicationData.cpfResponsavelLeg,
          birthdateResponsavelFin: legalIndicationData.birthdateResponsavelLeg,
          telResponsavelFin: legalIndicationData.telResponsavelLeg,
          emailResponsavelFin: legalIndicationData.emailResponsavelLeg,
        })
      } else {
        setFinancialIndicationData({
          ...financialIndicationData,
          nomeResponsavelFin: '',
          cpfResponsavelFin: '',
          birthdateResponsavelFin: '',
          telResponsavelFin: '',
          emailResponsavelFin: '',
        })
      }
    },
    [
      financialIndicationData,
      legalIndicationData.birthdateResponsavelLeg,
      legalIndicationData.cpfResponsavelLeg,
      legalIndicationData.emailResponsavelLeg,
      legalIndicationData.nomeResponsavelLeg,
      legalIndicationData.telResponsavelLeg,
      setFinancialIndicationData,
      setRespLegalEqualFin,
    ],
  )

  const handleChangePatrocinadora = useCallback(e => {
    const t = e
    setPatrocIndicacao(t)
  }, [patrocIndicacao])

  const handleChangeParentesco = useCallback(e => {
    const t = e
    setParentIndicacao(t)
  }, [parentIndicacao])

  useEffect(() => {
    if (pessoaIndicacao === 'S') {
      setTipoPessoa('F')
    } else {
      setTipoPessoa('P')
    }
  }, [pessoaIndicacao])

  return (
    <>
      <Header />
      <Container>
        <Form
          ref={formRef}
          onSubmit={handleSubmit}
          initialData={{
            nomeResponsavelLeg: legalIndicationData.nomeResponsavelLeg,
            cpfResponsavelLeg: legalIndicationData.cpfResponsavelLeg,
            birthdateResponsavelLeg:
              legalIndicationData.birthdateResponsavelLeg === undefined
                ? ''
                : legalIndicationData.birthdateResponsavelLeg
                  .split('-')
                  .reverse()
                  .join('/'),
            telResponsavelLeg: legalIndicationData.telResponsavelLeg,
            emailResponsavelLeg: legalIndicationData.emailResponsavelLeg,
            nomeResponsavelFin: financialIndicationData.nomeResponsavelFin,
            cpfResponsavelFin: financialIndicationData.cpfResponsavelFin,
            birthdateResponsavelFin:
              financialIndicationData.birthdateResponsavelFin === undefined
                ? ''
                : financialIndicationData.birthdateResponsavelFin
                  .split('-')
                  .reverse()
                  .join('/'),
            telResponsavelFin: financialIndicationData.telResponsavelFin,
            emailResponsavelFin: financialIndicationData.emailResponsavelFin,
            cpfIndicacao: indicationData.cpfIndicacao,
            nomeIndicacao: indicationData.nomeIndicacao,
            grauParentesco: indicationData.grauParentescoIndicacao,
          }}
        >
          <Content>
            <strong>
              Agora, preencha as informações sobre os responsáveis pelo seu
              plano:
            </strong>
            <InputHidden name="contribution" type="hidden" />
            <RadioButton>
              <label>Possui responsável legal?</label>
              <div>
                <BtnToggle
                  type="button"
                  isActive={respLegal}
                  onClick={() => setRespLegal(true)}
                  disabled={menorIdade}
                >
                  Sim
                </BtnToggle>
                <BtnToggle
                  type="button"
                  isActive={!respLegal}
                  onClick={() => setRespLegal(false)}
                  disabled={menorIdade}
                >
                  Não
                </BtnToggle>
              </div>
            </RadioButton>

            <Collapse in={respLegal}>
              <InputHidden
                type="hidden"
                name="responsavelLeg"
                value={respLegal ? 'S' : 'N'}
              />
              <Input
                placeholder="Nome do responsável legal"
                name="nomeResponsavelLeg"
                icon={FiUser}
                onChange={e => {
                  setLegalIndicationData({
                    ...legalIndicationData,
                    nomeResponsavelLeg: e.target.value,
                  })
                }}
              />
              <Input
                placeholder="CPF do responsável legal"
                name="cpfResponsavelLeg"
                icon={MdSecurity}
                mask="cpf"
                maxLength={14}
                onChange={e => {
                  setLegalIndicationData({
                    ...legalIndicationData,
                    cpfResponsavelLeg: e.target.value,
                  })
                }}
              />
              <Input
                icon={BiCake}
                name="birthdateResponsavelLeg"
                mask="date"
                placeholder="Data de nascimento do responsável legal"
                onChange={e => {
                  setLegalIndicationData({
                    ...legalIndicationData,
                    birthdateResponsavelLeg: e.target.value,
                  })
                }}
              />
              <Input
                placeholder="Telefone do responsável legal"
                name="telResponsavelLeg"
                type="tel"
                mask="phone"
                icon={FiSmartphone}
                onChange={e => {
                  setLegalIndicationData({
                    ...legalIndicationData,
                    telResponsavelLeg: e.target.value,
                  })
                }}
              />
              <Input
                placeholder="E-mail do responsável legal"
                name="emailResponsavelLeg"
                type="mail"
                icon={FiMail}
                onChange={e => {
                  setLegalIndicationData({
                    ...legalIndicationData,
                    emailResponsavelLeg: e.target.value,
                  })
                }}
              />
            </Collapse>

            <Line />
            <RadioButton>
              <label>Possui responsável financeiro?</label>
              <div>
                <BtnToggle
                  type="button"
                  isActive={respFinanceiro}
                  onClick={() => setRespFinanceiro(true)}
                  disabled={menorIdade}
                >
                  Sim
                </BtnToggle>
                <BtnToggle
                  type="button"
                  isActive={!respFinanceiro}
                  onClick={() => setRespFinanceiro(false)}
                  disabled={menorIdade}
                >
                  Não
                </BtnToggle>
              </div>
            </RadioButton>

            <Collapse in={respFinanceiro}>
              {respLegal ? (
                <RadioButton>
                  <label>
                    Responsável financeiro e responsável legal são a mesma
                    pessoa?
                  </label>
                  <div>
                    <BtnToggle
                      type="button"
                      isActive={respLegalEqualFin === 'S'}
                      onClick={() => toggleRespLegalEqualFin('S')}
                    >
                      Sim
                    </BtnToggle>
                    <BtnToggle
                      type="button"
                      isActive={respLegalEqualFin === 'N'}
                      onClick={() => toggleRespLegalEqualFin('N')}
                    >
                      Não
                    </BtnToggle>
                  </div>
                </RadioButton>
              ) : (
                <></>
              )}

              <Collapse in={respLegalEqualFin !== 'S'}>
                <InputHidden
                  type="hidden"
                  name="responsavelFin"
                  value={respFinanceiro ? 'S' : 'N'}
                />
                <Input
                  placeholder="Nome do responsável financeiro"
                  name="nomeResponsavelFin"
                  icon={FiUser}
                  value={financialIndicationData.nomeResponsavelFin}
                  onChange={e => {
                    setFinancialIndicationData({
                      ...financialIndicationData,
                      nomeResponsavelFin: e.target.value,
                    })
                  }}
                />
                <Input
                  placeholder="CPF do responsável financeiro"
                  name="cpfResponsavelFin"
                  icon={MdSecurity}
                  mask="cpf"
                  maxLength={14}
                  value={financialIndicationData.cpfResponsavelFin}
                  onChange={e => {
                    setFinancialIndicationData({
                      ...financialIndicationData,
                      cpfResponsavelFin: e.target.value,
                    })
                  }}
                />
                <Input
                  icon={BiCake}
                  name="birthdateResponsavelFin"
                  mask="date"
                  placeholder="Data de nascimento do responsável financeiro"
                  value={financialIndicationData.birthdateResponsavelFin}
                  onChange={e => {
                    setFinancialIndicationData({
                      ...financialIndicationData,
                      birthdateResponsavelFin: e.target.value,
                    })
                  }}
                />
                <Input
                  placeholder="Telefone do responsável financeiro"
                  name="telResponsavelFin"
                  type="tel"
                  mask="phone"
                  icon={FiSmartphone}
                  value={financialIndicationData.telResponsavelFin}
                  onChange={e => {
                    setFinancialIndicationData({
                      ...financialIndicationData,
                      telResponsavelFin: e.target.value,
                    })
                  }}
                />
                <Input
                  placeholder="E-mail do responsável financeiro"
                  name="emailResponsavelFin"
                  type="mail"
                  icon={FiMail}
                  value={financialIndicationData.emailResponsavelFin}
                  onChange={e => {
                    setFinancialIndicationData({
                      ...financialIndicationData,
                      emailResponsavelFin: e.target.value,
                    })
                  }}
                />
              </Collapse>
            </Collapse>
            <Line />
            <strong>Você foi indicado por alguma pessoa?</strong>
            <RadioButton>
              <label>Escolha uma opção:</label>
              <div>
                <BtnToggle
                  type="button"
                  isActive={pessoaIndicacao === 'S'}
                  onClick={() => setPessoaIndicacao('S')}
                >
                  Sim
                </BtnToggle>

                <BtnToggle
                  type="button"
                  isActive={pessoaIndicacao === 'N'}
                  onClick={() => setPessoaIndicacao('N')}
                >
                  Não
                </BtnToggle>
              </div>
            </RadioButton>

            <InputHidden
              type="hidden"
              name="pessoaIndicacao"
              value={pessoaIndicacao}
            />

            <Collapse in={pessoaIndicacao === 'S'} style={{ width: '100%' }}>
              <Input
                placeholder="CPF de quem te indicou"
                name="cpfIndicacao"
                icon={MdSecurity}
                type="tel"
                mask="cpf"
              />
              <Input
                placeholder="Nome de quem indicou"
                name="nomeIndicacao"
                icon={FiUser}
              />
              <InputSelect
                name="grauParentesco"
                options={[
                  { label: 'Conjuge', value: '1' },
                  { label: 'Companheiro(a)', value: '2' },
                  {
                    label: 'Filho(a) não emancipado menor de 21 anos',
                    value: '3',
                  },
                  { label: 'Filho(a) inválido(a)', value: '4' },
                  { label: 'Pai/mãe', value: '5' },
                  {
                    label:
                      'Irmão não emancipado menor de 21 anos com dependência econômica',
                    value: '6',
                  },
                  {
                    label: 'Irmão inválido com dependência econômica',
                    value: '7',
                  },
                  {
                    label:
                      'Enteado não emancipado menor de 21 anos com dependência econômica',
                    value: '8',
                  },
                  {
                    label: 'Enteado inválido com dependência econômica',
                    value: '9',
                  },
                  {
                    label:
                      'Menor tutelado não emancipado menor de 21 anos com dependência econômica',
                    value: '10',
                  },
                  {
                    label: 'Menor tutelado inválido com dependência econômica',
                    value: '11',
                  },
                  { label: 'Filho(a) maior de 21 anos', value: '12' },
                  { label: 'Outros', value: '0' },
                ]}
                placeholder="Grau de parentesco"
                onChange={e => handleChangeParentesco(e)}
                value={parentIndicacao}
              />
            </Collapse>
            <Collapse in={pessoaIndicacao === 'N'} style={{ width: '100%' }}>
              <InputSelect
                name='patrocinadoraIndicacao'
                options={[
                  { label: 'SERPROS', value: '2' },
                  { label: 'SERPRO', value: '8' }
                ]}
                placeholder='Empresa que te indicou'
                onChange={e => handleChangePatrocinadora(e)}
                value={patrocIndicacao}
              />
            </Collapse>
          </Content>
        </Form>

        <Button type="submit" color="green" onClick={handleClick}>
          Avançar
        </Button>
        <BtnVoltar
          type="button"
          onClick={() => history.push('/personal-infos')}
        >
          &lt; Anterior
        </BtnVoltar>

        <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
          <div className="confirmations">
            <p>
              Você confirma que o CPF {userData.cpf} pertence à {userData.name}?
            </p>
            <small>
              *Caso já exista um registro para este CPF e data de nascimento na
              base de dados, o cadastro será atualizado.
            </small>

            <div>
              <BtnModal
                isActive
                onClick={() => {
                  history.push('/goal-selection')
                  setIsModalOpen(false)
                }}
              >
                Confirmar
              </BtnModal>

              <BtnModal isActive isCancel onClick={() => setIsModalOpen(false)}>
                Cancelar
              </BtnModal>
            </div>
          </div>
        </ModalBox>
      </Container>
    </>
  )
}

export default Responsavel
